module.exports = __webpack_public_path__ + "img/NL786.359299bb.png";